import { organizationsActions } from './organizations-slice'
import store from './index'
import { handleError, handleSessionExpired } from './error-handler';

export const fetchOrganizationsList = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(organizationsActions.setIsLoading(true))
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/organizations',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch organizations list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const organizationsData = await fetchData()
            dispatch(organizationsActions.loadOrganizations({ organizations: organizationsData || [] }))

        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(organizationsActions.setIsLoading(false))

        }
    };
};

